module.exports = __webpack_public_path__ + "static/media/model_2.2308ee43.jpg";